import React from 'react';

export default function AriaLive(props) {
        return (
            <div className="aria-hidden" aria-live="polite" aria-atomic="true">
                {props.message}
            </div>
        )
}